export default "__VITE_ASSET__DyniZuKz__"